import { GovFormWeb } from '@gov-design-system-ce/react-form';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import { useMojeSouboryNahratContext } from '@gov-nx/module/page';
import {
	Button,
	Dialog,
	FormFileUpload,
	FormInput,
	FormWidthElementLayout,
	LayoutGap,
} from '@gov-nx/ui/web';
import { isAllUploaded } from '@gov-nx/utils/common';

export const MyFilesUploadForm = () => {
	const {
		code,
		isUploadModalOpened,
		formDefinition,
		onSubmit,
		isUploading,
		fileUploadHook,
	} = useMojeSouboryNahratContext();

	const { t } = useLocale(code);
	const { t: tForm } = useLocale(LocalizeNameSpaceTypes.Form);

	return (
		<GovFormWeb
			formDefinition={formDefinition}
			onSubmit={onSubmit}>
			<Dialog
				blockClose={isUploading || !isAllUploaded(fileUploadHook.files)}
				isOpen={isUploadModalOpened.value}
				onClose={isUploadModalOpened.setFalse}
				title={<h3>{tForm('nahrani-souboru.nahrat-soubor-ze-zarizeni')}</h3>}
				footer={
					<Button
						aria-label={t('akce.nahrat-soubor')}
						nativeType="submit"
						color="primary"
						isLoading={isUploading}
						isDisabled={isUploading || fileUploadHook.hasNotFinishedUploads}
						size="m"
						type="solid"
						isExpandedMobile>
						{t('akce.nahrat-soubor')}
					</Button>
				}>
				<LayoutGap gap="m">
					<FormFileUpload
						fileUploadHook={fileUploadHook}
						field={{ name: 'files', expanded: true, disabled: isUploading }}
					/>
					<FormWidthElementLayout type="l">
						<FormInput
							field={{
								name: 'name',
								size: 'l',
							}}
							label={{
								children: t('formular.pole.nazev-dokumentu'),
							}}
						/>
					</FormWidthElementLayout>
				</LayoutGap>
			</Dialog>
		</GovFormWeb>
	);
};
